<script type="text/ecmascript-6">
    import {mapGetters} from "vuex";

    export default {
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
            })
        },

        methods: {
            cancelLoading() {
                this.$store.dispatch('setIsLoading',false);
            }
        }
    }
</script>

<template>
    <div class="loading" v-show="isLoading">
        <div class="loading-icon">
            <div class="spinner-grow text-primary mb-3" style="width: 4rem; height: 4rem;" role="status">
            </div>
            <h5 class="text-black mb-3">This might take 5 seconds or 10 seconds above.</h5>
            <button class="btn btn-outline-primary" @click="cancelLoading"> Cancel</button>
        </div>
    </div>
</template>
